module.exports = __webpack_public_path__ + "img/20200731.d49dc95e.png";